<template>
  <div class="home-body">
    <!-- 左侧商品分类 -->
    <div class="category-sidebar">
      <h3 class="category-title">商品分类</h3>
      <el-carousel :initial-index="0" height="400px" class="category-carousel" @change="handleCategoryCarouselChange"
        indicator-position="none">
        <el-carousel-item v-for="(group, groupIndex) in categoryGroups" :key="groupIndex">
          <div class="category-list">
            <div v-for="(category, index) in group" :key="category.aid" class="category-item">
              <el-dropdown v-if="category.children && category.children.length > 0" trigger="hover"
                popper-class="sub-category-dropdown" placement="right-start">
                <div class="category-item-title">
                  <img :src="category.thumb" alt="分类图标" class="category-icon">
                  <span class="">{{ category.name }}</span>
                </div>
                <el-dropdown-menu slot="dropdown">
                  <div class="sub-category-content">
                    <el-dropdown-item v-for="(subCategory, subIndex) in category.children" :key="subIndex"
                      class="sub-category-item" @click.native="handleCategoryClick(subCategory, category.aid)">
                      {{ subCategory.name }}
                    </el-dropdown-item>
                  </div>
                </el-dropdown-menu>
              </el-dropdown>
              <div v-else class="category-item-title">
                <img src="@/assets/images/11.png" alt="分类图标" class="category-icon">
                <span>{{ category.name }}</span>
              </div>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>

    <!-- 中间内容区域 -->
    <div class="main-content" style="justify-content: space-between;">
      <!-- 轮播图 -->
      <el-carousel height="300px" class="banner-carousel">
        <el-carousel-item v-for="(item, index) in bannerList" :key="index">
          <div class="banner-image autumn-theme">
            <img :src="item.thumb" alt="轮播图" class="banner-image">
          </div>
        </el-carousel-item>
      </el-carousel>
      <!-- 商品推荐 -->
      <div class="recommendation-section">
        <div class="recommend-card" shadow="hover" @click="handleCategoryClick">
          <img :src="bannerLeft.thumb" alt="" mode="aspectFill" class="card-image">
        </div>
        <div class="recommend-card" shadow="hover" @click="goWailian">
          <img :src="bannerRight.thumb" alt="" mode="aspectFill" class="card-image">
        </div>
      </div>
    </div>

    <!-- 右侧用户服务面板 -->
    <div class="service-sidebar">
      <!-- 用户信息 -->
      <router-link to="/login" class="user-info" v-if="!isLoggedIn">
        <img src="@/assets/images/6.png"></img>
        <span class="user-greeting">Hi, 请登录</span>
      </router-link>
      <div class="user-info" v-if="isLoggedIn">
        <img :src="userInfo.avatar" alt="用户头像"></img>
        <span class="user-greeting">Hi, {{ userInfo.nickname }}</span>
      </div>

      <!-- 买家服务 -->
      <div class="service-section">
        <div class="service-section-box">
          <div class="service-section-line"></div>
          <div class="service-title">买家服务</div>
          <div class="service-section-line"></div>
        </div>
        <div class="service-items">
          <div class="service-item" @click="viewOrder">
            <img class="service-icon" src="@/assets/images/7.png" alt="我的订单" style="width: 60px; height: 60px;">
            <span>我的订单</span>
          </div>
          <div class="service-item" @click="goFabuCaigou">
            <img class="service-icon" src="@/assets/images/8.png" alt="发布采购" style="width: 60px; height: 60px;">
            <span>发布采购</span>
          </div>
        </div>
      </div>

      <!-- 卖家服务 -->
      <div class="service-section">
        <div class="service-section-box">
          <div class="service-section-line"></div>
          <div class="service-title">卖家服务</div>
          <div class="service-section-line"></div>
        </div>
        <div class="service-items">
          <div class="service-item">
            <img class="service-icon" src="@/assets/images/9.png" alt="发布商品" style="width: 60px; height: 60px;"
              @click="goFabuGoods">
            <span>发布商品</span>
          </div>
          <div class="service-item">
            <img class="service-icon" src="@/assets/images/10.png" alt="店铺订单" style="width: 60px; height: 60px;"
              @click="goShopOrders">
            <span>店铺订单</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { RouterLink } from 'vue-router';

export default {
  name: 'HomeBody',
  data() {
    return {
      userAvatar: '', // 用户头像URL
      categories: [],
      categoryGroups: [], // 分组后的分类数据
      currentGroupIndex: 0, // 当前轮播页索引
      bannerList: [],
      bannerLeft: {},
      bannerRight: {},
    }
  },

  mounted() {
    this.getHomeShopFenlei()
    this.getHomeShopBanner()
    this.getHomeShopBanner2()
  },
  computed: {
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
    userInfo() {
      return this.$store.getters.getUserInfo;
    },
    certifiedStatus() {
      return this.$store.state.certified;
    }
  },
  watch: {

  },

  methods: {
    // 处理分类轮播切换
    handleCategoryCarouselChange(index) {
      this.currentGroupIndex = index;
    },

    // 处理分类点击事件
    handleCategoryClick(category, pid) {
      // 获取aid（假设aid存在于category对象中）
      const aid = category.aid || category.id; // 兼容可能的不同字段名
      console.log('点击的分类aid:', aid, pid);
      // console.log('分类信息:', category);
      this.$emit('categoryClick', { aid, pid });

      // 这里可以添加后续处理逻辑，比如：
      // 1. 根据aid请求对应分类的商品列表
      // 2. 跳转到分类商品页面
      // 3. 更新页面状态等

      // 示例：跳转到分类商品页面
      // this.$router.push({ path: '/category', query: { aid: aid } });
    },

    // 查看订单
    viewOrder() {
      // 跳转到订单详情页，需要根据实际路由配置修改
      if (this.isLoggedIn) {
        this.$router.push({
          path: '/buyer',
          query: { componentName: 'MyOrders' }
        })
      } else {
        this.$message.error('请先登录');
      }

    },

    // 发布采购订单
    goFabuCaigou() {
      // 跳转到发布采购订单页，需要根据实际路由配置修改
      if (this.isLoggedIn) {
        this.$router.push({
          path: '/FabuCaigou',
        })
      } else {
        this.$message.error('请先登录');
      }

    },
    // 发布商品
    goFabuGoods() {
      // 跳转到发布商品页，需要根据实际路由配置修改
      if (this.isLoggedIn) {
        // 判断是否成为商家
        if (this.certifiedStatus == '5') {
          this.$router.push({
            path: '/seller',
            query: {
              component: 'ProductManagement'
            }
          });
        } else {
          this.$message.error('暂未成为商家');
        }
      } else {
        this.$message.error('请先登录');
      }
    },
    // 店铺订单
    goShopOrders() {
      // 跳转到店铺订单页，需要根据实际路由配置修改
      if (this.isLoggedIn) {
        // 判断是否成为商家
        if (this.certifiedStatus == '5') {
          this.$router.push({
            path: '/seller',
            query: {
              component: 'ShopOrders'
            }
          });
        } else {
          this.$message.error('暂未成为商家');
        }
      } else {
        this.$message.error('请先登录');
      }
    },
    // 获取中心分类数据
    getHomeShopFenlei() {
      this.$api.getHomeShopFenlei().then(res => {
        let list = res;
        this.categories = list;

        // 将数据分成每组12个
        this.categoryGroups = [];
        for (let i = 0; i < list.length; i += 12) {
          this.categoryGroups.push(list.slice(i, i + 12));
        }

        // 默认显示第一组
        this.currentGroupIndex = 0;
      }).catch(err => {
        this.$message.error(err);
      })
    },

    // 获取首页第一模块轮播图
    getHomeShopBanner() {
      let data = {
        type: 1,
      }
      this.$api.getHomeShopBanner(data).then(res => {
        this.bannerList = res;
      }).catch(err => {
        this.$message.error(err);
      })
    },

    // 获取下面的两个
    getHomeShopBanner2() {
      let data = {
        type: 4,
      }
      this.$api.getHomeShopBanner(data).then(res => {
        this.bannerLeft = res[0];
        this.bannerRight = res[1];
      }).catch(err => {
        this.$message.error(err);
      })
    },


    goWailian() {
      window.open(this.bannerRight.href)
    }
  }
}

</script>

<style scoped>
.home-body-wrapper {
  display: flex;
  justify-content: center;
}

.home-body {
  display: flex;
  width: 1200px;
  /* min-height: calc(100vh - 460px); */
  padding: 20px 0;
  gap: 20px;
  margin: 0 auto;
}

/* 左侧分类样式 */
.category-sidebar {
  width: 296px;
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  position: relative;
  z-index: 100;
}

.category-title {
  padding: 20px;
  margin: 0;
  font-size: 18px;
  border-bottom: 1px solid #f0f0f0;
  text-align: center;
}

.category-list {
  padding: 10px 0;
  display: flex;
  flex-wrap: wrap;
  text-align: left;
}

.category-item {
  position: relative;
  width: 50%;
  box-sizing: border-box;
}

.category-item-title {
  padding: 12px 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: left;
  transition: all 0.3s;
  height: 100%;
  box-sizing: border-box;
  font-size: 16px;

}

.shenglue {
  line-clamp: 1;
  -webkit-line-clamp: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}

.category-item-title:hover {
  background-color: #ecf5ff;
  color: #286CED;
}

.category-icon {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  object-fit: cover;
}

/* 二级分类弹窗样式 */
.sub-category-dropdown {
  width: 300px;
  padding: 6px;
  min-height: 0 !important;
}

.sub-category-dropdown .el-dropdown-menu {
  padding: 0;
  border: none;
  min-height: 0 !important;
}

.sub-category-content {
  display: grid;
  grid-template-columns: repeat(10, 1fr);
  gap: 2px;
  max-height: 400px;
  overflow-y: auto;
}

.sub-category-item {
  padding: 3px 6px;
  cursor: pointer;
  border-radius: 4px;
  transition: all 0.3s;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 14px;
  line-height: 1.3;
}

.sub-category-item:hover {
  background-color: #ecf5ff;
  color: #286CED;
}

/* 中间内容区域样式 */
.main-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.banner-carousel {
  border-radius: 8px;
  overflow: hidden;
}

.banner-image {
  width: 100%;
  height: 300px;
  background-color: #f0f0f0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: white;
}

.autumn-theme {
  background: linear-gradient(135deg, #ff9a9e 0%, #fecfef 50%, #fecfef 100%);
}

.recommendation-section {
  display: flex;
  gap: 20px;
}

.recommend-card {
  flex: 1;
  border-radius: 8px;
}

.card-content {
  display: flex;
  align-items: center;
  gap: 20px;
}

.card-image {
  width: 100%;
  height: 160px;
  background-color: #f0f0f0;
  border-radius: 8px;
}

.seedling-image {
  background: linear-gradient(135deg, #a8edea 0%, #fed6e3 100%);
}

.seasoning-image {
  background: linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%);
}

.card-info {
  flex: 1;
}

.card-info h4 {
  margin: 0 0 10px 0;
  font-size: 16px;
}

.card-info p {
  margin: 0 0 15px 0;
  color: #666;
  font-size: 14px;
}

/* 右侧服务面板样式 */
.service-sidebar {
  width: 250px;
  /* background-color: #f0f7ff; */
  background-image: url('../../assets/images/5.png');
  background-size: cover;
  /* background-image: none; */
  border-radius: 12px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  padding: 30px 20px;
  border: 1px solid #e6f2ff;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 25px;
  padding-bottom: 15px;
  border-bottom: 1px dashed #c9e3ff;
}

.user-info img {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  border: 2px solid #286CED;
}

.user-greeting {
  font-size: 14px;
  font-weight: 500;
  color: #333;
}

.service-section {
  margin-bottom: 25px;

}

.service-section-box {
  display: flex;
  align-items: center;
  justify-content: center;
}

.service-section-line {
  width: 24px;
  height: 1px;
  background: #999999;
  border-radius: 0px 0px 0px 0px;
}

.service-title {
  /* margin: 0 0 15px 0; */
  font-size: 16px;
  color: #286CED;
  text-align: center;
  position: relative;
  font-weight: bold;
  margin: 0 12px;
  /* padding-bottom: 8px; */
}

/* .service-title::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 60px;
  height: 2px;
  background-color: #286CED;
} */

.service-items {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 25px 20px;
}

.service-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  transition: all 0.3s;
  color: #666;
}

.service-item:hover {
  color: #286CED;
  transform: translateY(-2px);
}

.service-icon {
  width: 60px;
  height: 60px;
  background-color: #ffffff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px dashed #c9e3ff;
  color: #286CED;
  width: 50px;
  height: 50px;
  box-sizing: border-box;
}
</style>